import request from "@utils/request";
import url from "@utils/url";
// const TEST_HOST = 'http://10.1.0.85:39003'

const { HOST } = url;

export async function getAllGames() {
  const url = `${HOST}/cps-gateway/api/v1/stat/game`;
  // const url = `${TEST_HOST}/cps-gateway/api/v1/stat/game`;

  return request({ method: "get", url: url });
}

export async function getAllTarget(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/target`;
  // const url = `${TEST_HOST}/cps-gateway/api/v1/stat/target`;

  return request({ method: "get", url: url }, data);
}

export async function setTarget(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/target`;

  return request({ method: "post", url: url }, data);
}

export async function searchData(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/cps/info`;
  // const url = `${TEST_HOST}/cps-gateway/api/v1/stat/cps/info`;

  return request({ method: "post", url: url, noLoading: true }, data);
}

export async function searchSumData(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/cps/sum/info`;

  return request({ method: "post", url: url, noLoading: true }, data);
}

export async function searchDataVPCV2(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/cps/vpc/info/v2`;
  return request({ method: "post", url, noLoading: true }, data);
}

export async function searchDataVPC(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/cps/vpc/info`;
  return request({ method: "post", url, noLoading: true }, data);
}

export async function download(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/download`;
  // const url = `http://10.1.1.66:39003/cps-gateway/api/v1/stat/download`;

  return request({ method: "post", url: url, responseType: "blob" }, data);
}

export async function downloadVPC(data) {
  const url = `${HOST}/cps-gateway/api/v1/stat/vpc/download`;
  return request({ method: "post", url: url, responseType: "blob" }, data);
}
